const menuMobileIcon = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 9H20M4 12.2941H20M4 15.5882H20" stroke="#65758C" stroke-linecap="square"/>
</svg>
`

export default menuMobileIcon
